import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';

export const SberPayButton = styled(Button)`
    background-color: #21A038;

    &:hover {
        background-color: #25b33f;
    }
`;

export const InnerWrap = styled.div`
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
`;
